export default __webpack_public_path__ + "static/media/bg_gift.905858af.png";